import React, { useEffect, useState } from "react"
import { Row, Col, Button } from "reactstrap"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { Table as AntdTable } from "antd"
import {
  dateFormatter,
  dateSorter,
  defaultPageSizeOptions,
  getAlarmColor,
  stringSorter,
} from "utils/general"
import { tableDefaultHeight } from "constants/layout"

const AlarmMonitoringTable = props => {
  const [alarmsData, setAlarmsData] = useState([])

  //Setting data state
  useEffect(() => {
    setAlarmsData(props.data)
    //console.log(props.data)
  }, [props.data])

  const actionsFormatter = (cell, row) => (
    <Button
      color="primary"
      outline
      size="sm"
      id={row.id}
      onClick={() => {
        props.setShowDrawer(true)
        props.setSelectedRow(row)
      }}
    >
      {props.t("Show")}
    </Button>
  )

  function alarmFormatter(cell, row) {
    const iconByStatus = {
      CLOSED: "bx bx-check-circle font-size-20 text-success",
      ASSIGNED: "bx bxs-calendar-heart font-size-20 text-warning",
      ACTIVE: "bx bxs-calendar-heart font-size-20 text-danger",
    }
    const iconClass = iconByStatus[row.status] || iconByStatus.ACTIVE
    const color = getAlarmColor(row.alarm_id)

    return (
      <span style={{ display: "flex", alignItems: "center" }}>
        <i className={iconClass} style={{ marginRight: 26 }} />
        <span
          style={{
            display: "inline-block",
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor: color,
            marginRight: 8,
          }}
        />
        <span>{props.t(cell)}</span>
      </span>
    )
  }

  // Table structure
  const columns = [
    {
      dataIndex: "action",
      title: "",
      align: "center",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" }
      },
      render: actionsFormatter,
      fixed: "left",
    },
    {
      dataIndex: "description",
      title: props.t("Alarm"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "description", sortOrder)
      },
      render: alarmFormatter,
    },
    {
      dataIndex: "extra_info",
      title: props.t("Info"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "extra_info", sortOrder)
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "client",
      title: props.t("Customer"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "client", sortOrder)
      },
    },
    {
      dataIndex: "updated_at",
      title: props.t("Time"),
      sorter: (a, b, sortOrder) => {
        return dateSorter(a["updated_at"], b["updated_at"], sortOrder)
      },
      render: dateFormatter,
    },
  ]

  return (
    <React.Fragment>
      <Row>
        <Col className="col-12">
          {alarmsData != undefined && (
            <AntdTable
              className="clear-header"
              bordered={false}
              size="middle"
              loading={props.loading}
              sticky
              rowKey={"key"}
              columns={columns}
              dataSource={alarmsData}
              pagination={{
                showSizeChanger: true,
                defaultPageSize: 50,
                pageSizeOptions: defaultPageSizeOptions,
              }}
              tableLayout="auto"
              scroll={{
                x: "max-content",
                y: tableDefaultHeight,
              }}
            />
          )}
        </Col>
      </Row>
    </React.Fragment>
  )
}

AlarmMonitoringTable.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
  setShowDrawer: PropTypes.func,
  setSelectedRow: PropTypes.func,
  loading: PropTypes.bool,
}

export default withTranslation()(AlarmMonitoringTable)
